import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import { Checkbox } from 'antd';
import style from './UnassignedCheckbox.module.scss';

const UnassignedCheckbox: React.FC = () => {
	const { changeIsUnassignedFirmwareStatus, isUnassignedFirmware } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	return (
		<Checkbox
			className={style.checkbox}
			onChange={(e) => changeIsUnassignedFirmwareStatus(e.target.checked)}
			checked={isUnassignedFirmware}
			data-test="UnassignedCheckbox">
			<Text translationNameSpace="listing" translationKey="unassignedFirmwareLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedCheckbox;
